import * as THREE from 'three';
import { WIDTH, HEIGHT, THREE_DRAW_DISTANCE, THREE_FOV } from '@/constants';

const camera = new THREE.PerspectiveCamera(
    THREE_FOV,
    WIDTH / HEIGHT,
    1,
    THREE_DRAW_DISTANCE
);
camera.position.y = -226;
camera.position.z = 255;
camera.rotation.x = 1.110;
camera.lookAt(0,0,0)
// camera.updateProjectionMatrix();
window.camera = camera;


export default camera;